import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function Card({ title, desc, children, testid, aside }) {
  return (
    <section className="bg-white border border-slate-200 rounded-xl p-6" data-testid={testid}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <h2 className="text-base font-semibold text-slate-900">{title}</h2>
          {desc && <p className="mt-1 text-sm text-slate-500">{desc}</p>}
        </div>
        {aside}
      </div>
      <div className="mt-5 space-y-4">{children}</div>
    </section>
  );
}

export function Row({ label, hint, children }) {
  return (
    <div className="grid sm:grid-cols-[200px_1fr] gap-2 sm:items-center">
      <div><p className="text-sm text-slate-600">{label}</p>{hint && <p className="text-[11px] text-slate-400">{hint}</p>}</div>
      <div className="min-w-0">{children}</div>
    </div>
  );
}

export function Pick({ value, onChange, options, testid, className = "max-w-sm" }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={`bg-white ${className}`} data-testid={testid}><SelectValue /></SelectTrigger>
      <SelectContent>{options.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
    </Select>
  );
}
